var portfolio = {
	addTransactionAction: "Add Transaction",
	topFlopTitle: "Top/Flop Position",
	breakdownsTitle: "Breakdown information",
	assetClassBreakdownTitle: "Asset classes",
	currencyBreakdownTitle: "Currencies",
	sectorBreakdownTitle: "Sectors",
	sectorBreakdownSubtitle: "Weighting to the total portfolio",
	evaluationChartTitle: "Portfolio value",
	unrealizedPerformancePositionsTitle: "Unrealized performance",
	weightPositionsTitle: "Portfolio weight",
	editPortfolioAction: "Edit Portfolio",
	deletePortfolioAction: "Delete Portfolio",
	createPortfolioAction: "Create Portfolio",
	addPortfolioAction: "Add Portfolio",
	editTransactionAction: "Edit Transaction",
	deleteTransactionAction: "Delete Transaction",
	errorAlertLabel: "An error occurred",
	transactionLimitExceeded: "Transaction limit exceeded",
	portfolioLimitExceeded: "Portfolio limit exceeded",
	info: "Info",
	noPositionsAlert: "The portfolio does not contain any positions, please add a purchase transaction",
	noTransactionsAlert: "The portfolio does not contain any transactions, please add a purchase transaction",
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	tab: {
		overview: "Overview",
		positions: "Positions",
		transactions: "Transactions",
		news: "News"
	},
	showActions: "Show actions"
};
var en = {
	portfolio: portfolio
};

export { en as default, portfolio };
